
import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { SpeakerService } from '../../speaker.service';
import { User, displayColumns,displayHeaders, filterParameters } from './user.interface';
import { CommonApiService } from "../../common-api.service";
import { FilterBuilderComponent } from '../filter-builder/filter-builder.component';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { RenderFilterDropdownService } from '../../render-filter-dropdown.service';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ListStateService } from '../../list-state.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})

export class UserComponent implements OnInit, OnDestroy {

    
    displayColumns = displayColumns;
    displayHeaders = displayHeaders;
    user: User[] =[];
    filterFields: any[] =[]
    filterCriteria: any[] =[] 
    roleOptions:any[] = [];
    pageIndex = environment.defaultPageIndexOnLoad;
    pageSize = environment.defaultPageSizeOnLoad;
    sortQuery = 'id:1';
    private destroy$ = new Subject<void>();

    @ViewChild('dynamicFilterContainer', { read: ViewContainerRef, static: true })
	dynamicFilterContainer!: ViewContainerRef;

    constructor(
        public speaker: SpeakerService,
        private api: CommonApiService,
        private router: Router,
		private dialog: MatDialog,
        private renderFilterDropdown: RenderFilterDropdownService,
        private listState: ListStateService
    ) { }


    ngOnInit(): void {
        this.speaker.model = 'auth';
        this.speaker.displayColumns = this.displayColumns;
        this.speaker.displayHeaders = this.displayHeaders;

        const cached = this.listState.restore(this.speaker.model);
        if (cached) {
            this.pageIndex = cached.pageIndex;
            this.pageSize = cached.pageSize;
            this.sortQuery = cached.sortQuery;
            this.filterCriteria = cached.filterCriteria;
            this.speaker.activeView = cached.activeView;
        }
        this.speaker.pageIndex = this.pageIndex;
        this.speaker.pageSize = this.pageSize;
        this.speaker.sortQuery = this.sortQuery;

        this.speaker.paginationChange$.pipe(takeUntil(this.destroy$)).subscribe(({ pageIndex, pageSize, sortQuery }) => {
            this.pageIndex = pageIndex;
            this.pageSize = pageSize;
            this.sortQuery = sortQuery;
            this.getListDetails();
        });
        this.speaker.activeView$.pipe(takeUntil(this.destroy$)).subscribe(() => this.getListDetails());
        this.getListDetails();
        this.onDropdownRenderOptions('userrole/list/display', this.roleOptions);
    }

    // dynamic func for dropdown loading in filters
    onDropdownRenderOptions(apiEndpoint: string, targetOptions: any[]) {
        this.renderFilterDropdown.onDropdownLoadOptions(apiEndpoint, targetOptions);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    getListDetails() {

        const params: any = {
            offset: this.pageIndex,
            limit: this.pageSize,
            sort: this.sortQuery,
            active: this.speaker.activeView,
            filterCriteria: this.filterCriteria
        };

        this.api.postAll('auth/list/display', params).subscribe((res: any) => {

            this.user = res.items;
            this.user.forEach((element) => {
                if(element.role){
                    element.role_name = element.role.name;
                }
            });
            this.speaker.setListData(this.user, res.rowCount, res.pageIndex, res.pageSize);
            this.listState.save(this.speaker.model, { pageIndex: this.pageIndex, pageSize: this.pageSize, sortQuery: this.sortQuery, filterCriteria: this.filterCriteria, activeView: this.speaker.activeView });
        });
    }
    // set options for dropdown filters
    getOptionArray<T>(modelName: any): T[] {
        const ModelOptionsMap: Record<string, T[]> = {
          userrole: this.roleOptions,
          // Add other model names and their corresponding options arrays here
        };
        
        const optionKey = ModelOptionsMap[modelName];
        return optionKey;
    }

    openDialogFilter() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'custom-dialog-container';
        dialogConfig.data = {
            filterFields: filterParameters.map(field => field),
        };
        const dialogRef = this.dialog.open(FilterBuilderComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.filterCriteria = result;
                this.pageIndex = environment.defaultPageIndexOnLoad;
                this.pageSize = environment.defaultPageSizeOnLoad;
                this.getListDetails();
            }
        });
    }

    resetFilters() {
        this.listState.clear(this.speaker.model);
        this.redirectTo(this.speaker.model);
    }

    //redirects to the expected route
    //this function will redirect to a dummy route and quickly return to the destination route without the user realizing it.
    redirectTo(uri:string){  
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
        this.router.navigate([uri]));
    }
}

